<div class="flex flex-col flex-auto min-w-0">
    <app-drake-quickedit [scope]="scope" [viewCode]="viewCode" [filter]="filter" [sort]="sort"></app-drake-quickedit>
</div>
